import React from 'react';
import { NavLink } from 'react-router-dom';
import image from  '../assets/logo.png';

const AuthPage = () => {
  return (
    <>
       <header className="App">
    
    
    <nav className="navbar-nav navbar navbar-expand-lg navbar-light bg-light ">   
  
     
       
       <NavLink className="navbar-brand" href="/">
         <img
           className="logo-ifc"
           src={image}
           alt="logo ifc"
          
           width='60px'
         />
       </NavLink >
       
     
       <ul className="nav navbar-nav">
         <li className="">
           <NavLink to="/accueil">Accueil</NavLink>
         </li>
         <li className="">
           <NavLink to="/Examen">Faqs</NavLink>
         </li>
         <li className="">
           <NavLink to="/Contact">Contact</NavLink>
         </li>
     
         <li className="">
           <NavLink to="/"></NavLink>
         </li>
         <li className="">
           <NavLink to="/espCandidat">EspaceCandidat</NavLink>
         </li>
       </ul>
     
   
 </nav>
 </header>
    <div style={{ backgroundColor: '#f0f8ff', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
       

      <form style={{ backgroundColor: '#ffffff', padding: '50px',width: '50%', borderRadius: '5px', boxShadow: '0 200px 100px rgba(0,0,0,0.1)' }}>
        <h2 style={{ textAlign: 'center' }}>Espace du Candidat</h2>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>Email</label>
          <input type="email" style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }} required />
        </div>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>Mot de passe</label>
          <input type="password" style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }} required />
        </div>
        <button type="submit" style={{ width: '100%', padding: '10px', backgroundColor: '#007BFF', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
          Se connecter
        </button>
        <p style={{ textAlign: 'center', marginTop: '10px' }}>
          <a href="#" style={{ color: '#007BFF', textDecoration: 'none' }}>Mot de passe oublié ?</a>
        </p>
      </form>
    </div>
    </>
  );
};

export default AuthPage;
